import React from 'react';
import { CtaBlock } from './ui/CtaBlock';
import { OFFER_ANCHOR, PACK_IMAGE, PACK_IMAGE_ALT, PRODUCT_NAME } from '../data/content';
export function Hero() {
  return <header className="bg-navy" data-id="element-86" data-mp="ei1vfm5pk2xy">
      <div className="mx-auto max-w-3xl px-4 pb-4 pt-3 text-center sm:pt-6" data-id="element-87" data-mp="9k0f38zo2hq6">
        <p className="font-condensed text-xs font-extrabold uppercase tracking-wide text-energy sm:text-sm" data-id="element-88" data-mp="4lyvmmybwge6">
          ⚡ Método de enseñanza paso a paso
        </p>
        <h1 className="mt-1 font-display text-[1.55rem] font-black leading-[1.1] text-white sm:text-5xl" data-id="element-89" data-mp="128pgza8jqr2z">
          El sistema completo para preparar y enseñar electrónica{' '}
          <span className="text-energy" data-id="element-90" data-mp="s9zwrat6gujk">de forma práctica y organizada</span>
        </h1>
        <p className="mx-auto mt-1.5 max-w-2xl text-sm leading-snug text-white/80 sm:text-base" data-id="element-91" data-mp="nb6mdr96tjnm">
          Organiza tus clases, explica componentes y circuitos, prepara mediciones, prácticas, ejercicios, evaluaciones
          y proyectos para tus alumnos — sin perder horas buscando información y armando cada clase desde cero.
        </p>

        <p className="mt-2.5 rounded-md border-2 border-energy bg-brand px-3 py-1.5 font-condensed text-[0.78rem] font-bold leading-tight text-white sm:text-base" data-id="element-92" data-mp="3j6g1pzwctvil">
          ⚡ {PRODUCT_NAME} ·{' '}
          <span className="font-numeric text-base font-normal tracking-wide text-energy sm:text-xl" data-id="element-93" data-mp="39cfotbutzlzb">
            6 Tomos + 5 Bonos
          </span>
        </p>

        <a href={OFFER_ANCHOR} aria-label="Ir a la sección de compra" className="mx-auto mt-2 block max-w-xl overflow-hidden rounded-lg transition-transform duration-150 ease-[cubic-bezier(0.23,1,0.32,1)] active:scale-[0.99]" data-id="element-94" data-mp="30h9blrt8e1mr">
          <img src={PACK_IMAGE} alt={PACK_IMAGE_ALT} className="block w-full" data-id="element-95" data-mp="2viojkfo4uo9e" />
        </a>

        <CtaBlock onDark note="Acceso Digital Inmediato • Garantía de 7 Días" data-id="element-96" data-mp="2hjf63nrba894" />
      </div>
    </header>;
}